import { Controller } from "@hotwired/stimulus"

// Repopulates the club select with the clubs for the selected event year
// whenever the year select changes, preserving the current selection when
// that club still exists in the newly selected year. Bonus stations are
// grouped under an optgroup at the bottom.
export default class extends Controller {
  static targets = ["yearSelect", "clubSelect"]
  static values = { byYear: Object }

  refresh() {
    const year = this.yearSelectTarget.value
    const groups = this.byYearValue[year] || { regular: [], bonus: [] }
    const previous = this.clubSelectTarget.value

    this.clubSelectTarget.innerHTML = ""
    const regular = groups.regular || []
    const bonus = groups.bonus || []

    if (bonus.length > 0) {
      this.appendGroup(this.clubSelectTarget, "Clubs", regular, previous)
      this.appendGroup(this.clubSelectTarget, "Bonus Stations", bonus, previous)
    } else {
      this.appendOptions(this.clubSelectTarget, regular, previous)
    }
  }

  appendGroup(parent, label, options, previous) {
    const optgroup = document.createElement("optgroup")
    optgroup.label = label
    this.appendOptions(optgroup, options, previous)
    parent.appendChild(optgroup)
  }

  appendOptions(parent, options, previous) {
    options.forEach(([label, value]) => {
      const option = document.createElement("option")
      option.value = value
      option.textContent = label
      option.selected = value === previous
      parent.appendChild(option)
    })
  }
}
